export default __webpack_public_path__ + "static/media/icon_like-4.f4298f15.svg";